import { IconClock, IconMapPin } from "../icons/IconsPaciente";
import { BadgeEstado } from "../utils/Utils";
import "./TurnoCard.css";

const TurnoCard = ({ turno, proximos, onCancelar, onEditar }) => (
    <div className={`turno-card${proximos ? " turno-card--proximos" : ""}`}>
        <div className="turno-card__header">
            <div className="turno-card__avatar">{turno.medico.split(" ").pop().charAt(0)}</div>
            <div className="turno-card__info">
                <p className="turno-card__medico">{turno.medico}</p>
                <p className="turno-card__especialidad">{turno.especialidad}</p>
            </div>
            <BadgeEstado estado={turno.estado} />
        </div>
        <div className="turno-card__meta">
            <span><IconClock /> {turno.fecha} · {turno.hora}</span>
            <span><IconMapPin /> {turno.sede}</span>
        </div>
        {proximos && ["confirmado", "reservado", "pendiente_confirmacion"].includes(turno.estado) && (
            <div className="turno-card__actions">
                <button className="btn-ghost btn-ghost--danger" onClick={() => onCancelar?.(turno)}>Cancelar</button>
                <button className="btn-ghost" onClick={() => onEditar?.(turno)}>
                    {turno.estado === "pendiente_confirmacion" ? "Ver solicitud" : "Cambiar fecha"}
                </button>
            </div>
        )}
    </div>
);

export default TurnoCard;